import { FC, memo, useCallback, useEffect, useState } from 'react'

import { Form, useFormData } from 'brief-form'
import { ButtonGroup } from 'ui/components/ButtonGroup'
import { Button } from 'ui/components/Buttons'
import { Info, InfoSet, InfoSetDirection } from 'ui/components/Info'
import { TextareaInput } from 'ui/components/InputV2'
import { QuarterlyReportStatusLabel } from 'ui/components/Labels'
import { LeaveConfirmation } from 'ui/components/LeaveConfirmation'
import { PageSectionPrimary } from 'ui/components/Page'
import { Col, Col2x, FormRow, Row } from 'ui/themes/globalStyles'

import { GeneralInformationProps } from './GeneralInformationProps'

import * as SC from './styles'

export const GeneralInformation: FC<GeneralInformationProps> = memo(({ item, openMonthly, onSaveNotes }) => {
  const { config, isDirty, Field, set } = useFormData<{ infoNotes: string }>({
    initialValue: { infoNotes: item?.infoNotes }
  })
  const [submitting, setSubmitting] = useState(false)

  useEffect(() => {
    set({ reset: true, value: { infoNotes: item?.infoNotes } })
  }, [item])

  const onSaveWrapper = useCallback(async () => {
    try {
      setSubmitting(true)
      await onSaveNotes({ id: item?.quarterlyAnalyticsId, notes: config.value.infoNotes })
    } finally {
      setSubmitting(false)
    }
  }, [onSaveNotes, config.value, item?.quarterlyAnalyticsId])

  return (
    <LeaveConfirmation preventLeaving={isDirty && !submitting}>
      <PageSectionPrimary
        face="outlined"
        title="General Information"
        anchor="general"
        actions={
          <Button face="tertiary" onClick={openMonthly}>
            Show Monthly Analytics
          </Button>
        }
      >
        <InfoSet direction={InfoSetDirection.COLUMN}>
          <Row>
            <Col>
              <Info label="Relationship Name">
                <SC.WrappedLink to="/relationships/$id" params={{ id: item.infoRelationshipId.toString() }}>
                  {item.infoRelationshipName || '---'}
                </SC.WrappedLink>
              </Info>
            </Col>
            <Col>
              <Info label="Period">{item?.infoPeriod}</Info>
            </Col>
          </Row>
          <Row>
            <Col>
              <Info label="Report Status">
                <QuarterlyReportStatusLabel name={item?.infoStatus} />
              </Info>
            </Col>
          </Row>
          {item?.infoNotes !== undefined && (
            <Form config={config}>
              <FormRow>
                <Col2x>
                  <Field name="infoNotes" label="Notes" input={TextareaInput} inputProps={{}} />
                </Col2x>
              </FormRow>
              {item?.enableSaveNotes && (
                <FormRow>
                  <Col2x>
                    <ButtonGroup margin="small">
                      <Button onClick={onSaveWrapper} loading={submitting} face="tertiary">
                        Save Notes
                      </Button>
                    </ButtonGroup>
                  </Col2x>
                </FormRow>
              )}
            </Form>
          )}
        </InfoSet>
      </PageSectionPrimary>
    </LeaveConfirmation>
  )
})
